import { cardsData } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-extrabold text-foreground-900">图文资讯</h2>
          <p className="text-sm text-foreground-600 mt-2">精选影视资讯与观影指南，帮你从海量内容中发现心头好</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsData.map((item) => (
            <article key={item.id} className="group cursor-pointer">
              <div className="relative rounded-xl overflow-hidden aspect-[3/2] mb-3 md:mb-4 bg-background-100">
                <img
                  src={item.image}
                  alt={`91视频 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-900 group-hover:text-primary-600 transition-colors mb-1.5">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}